import { useTranslation } from "react-i18next";

import Button from "components/Button";
import Header from "components/Header";

import CancelSessionDialog from "../CancelSessionDialog";

import { useSessionHeader } from "./useSessionHeader";

export default function SessionHeader() {
  const { t } = useTranslation();
  const { cancelSessionMutation, open, setOpen, id, handleCancelSession } = useSessionHeader();

  return (
    <Header className="justify-between">
      <div className="flex items-center gap-2">
        <div className="flex items-center gap-2">{t("menu.session")}</div>
      </div>
      <div className="flex items-center gap-4">
        <CancelSessionDialog
          open={open}
          setOpen={setOpen}
          cancelSession={() => cancelSessionMutation.mutate(id as string)}
        />
        <Button variant={"ghost"} size="small" onClick={handleCancelSession}>
          {t("button.cancel")}
        </Button>
      </div>
    </Header>
  );
}
